// extracted by mini-css-extract-plugin
module.exports = {"name":"styles_name__20I_z","smallIcon":"styles_smallIcon__35-jw"};